// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DoubleRightOutlinedSvg from "@fishx/icons-svg/es/asn/DoubleRightOutlined";
import FishxIcon from '../components/FishxIcon';

var DoubleRightOutlined = function DoubleRightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DoubleRightOutlinedSvg
  }));
};

DoubleRightOutlined.displayName = 'DoubleRightOutlined';
export default React.forwardRef(DoubleRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DoubleRightOutlined.js
// module id = 2447
// module chunks = 0